<template>
  <div class="">

    <div class="declare_outer" :class="{'view':mode=='view'}">
      <div class="declare_cont">
        <div class="head">
          <div class="tit">
            上海市工业综合开发区产业创新和发展基金项目申报表
          </div>
        </div>

        <div class="">
          <el-form :model="sbInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="form_cont_module">
              <div class="m_head">
                一、企业概况
              </div>
              <div class="d_content">
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg">企业名称 <span style="color: red;font-weight: bold">*</span></td>
                    <td colspan="3">
                    	<el-form-item  prop="cname">
                      	<el-input v-model="sbInfo.cname" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
											</el-form-item>
                      <el-autocomplete v-if="false"
                        v-model="cnameGL"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入内容"
                        @select="handleSelect"
                        style="width: 100%;"
                      ></el-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">企业性质</td>
                    <td>
                    	<el-form-item  prop="qyxz">
	                      <el-select v-model="sbInfo.qyxz" placeholder="请选择" style="width:100%" :disabled="mode==='view'">
	                        <el-option
	                          v-for="item in qyxzOpts"
	                          :key="item.value"
	                          :label="item.label"
	                          :value="item.value">
	                        </el-option>
	                      </el-select>
	                    </el-form-item>
                    </td>
                    <td class="td_bg">法人代表</td>
                    <td>
                      <el-input v-model="sbInfo.opername" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">成立日期</td>
                    <td>
                    	<el-form-item prop="startday">
	                      <el-date-picker  :readonly="mode==='view'"
	                        v-model="sbInfo.startday"
	                        value-format="yyyy-MM-dd"
	                        placeholder="选择日期"
	                        style="width:100%">
	                      </el-date-picker>
	                    </el-form-item>
                    </td>
                    <td class="td_bg">所属行业</td>
                    <td>
                      <el-input v-model="sbInfo.sshy" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">企业地址</td>
                    <td colspan="3">
                      <el-input v-model="sbInfo.address" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">主要产品</td>
                    <td colspan="3">
                      <el-input v-model="sbInfo.zycp" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">经办人 <span style="color: red;font-weight: bold">*</span> </td>
                    <td>
                      <el-form-item  prop="agent">
                            <el-input v-model="sbInfo.agent" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                      </el-form-item>
                    </td>
                    <td class="td_bg">联系电话 <span style="color: red;font-weight: bold">*</span> </td>
                    <td>
                      <el-form-item  prop="corp_tel">
                         <el-input v-model="sbInfo.corp_tel"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                      </el-form-item>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="form_cont_module">
              <div class="m_head">
                二、申报项目概况
              </div>
              <div class="d_content">
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg">申报大类</td>
                    <td>
                      <el-select v-model="sbInfo.sb_cate" placeholder="请选择" @change="indChange" style="width:100%" :disabled="mode==='view'">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                    <td class="td_bg">申报小类</td>
                    <td>
                      <el-input v-model="sbInfo.sbxl" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                    <td class="td_bg">项目编号</td>
                    <td>
                      <el-input v-model="sbInfo.xmbh" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">项目简介</td>
                    <td colspan="5">
                      <el-input type="textarea" :row="4" v-model="sbInfo.pro_intro" placeholder="请输入内容" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6" style="border-left: 0;border-right:0;padding:18px 8px;">申报项目佐证材料（请罗列清单并附附件）：</td>
                  </tr>
                  <tr>
                    <td class="td_bg" colspan="2">序号</td>
                    <td class="td_bg" colspan="2">文件名称</td>
                    <td class="td_bg text_center">上传时间</td>
                    <td class="td_bg text_center">操作</td>
                  </tr>
                  <tr v-for="(item,index) in filesList">
                    <td colspan="2">{{ index + 1 }}</td>
                    <td colspan="2">{{ item.name }}</td>
                    <td class="text_center">{{ item.create_time }}</td>
                    <td>
                      <div class="btn_outer text_center">
                        <el-button type="success" @click="downloadFile(item.filepath,item.name)" plain><i
                          class="cloudicon ci_download"></i>
                          下载
                        </el-button>
                        <el-button v-if="mode!=='view'" type="danger" @click="del(index)" plain><i class="cloudicon ci_delect"></i>

                          删除
                        </el-button>
                      </div>
                    </td>
                  </tr>
                  <tr  v-if="mode!=='view'">
                    <td colspan="6">
                      <div class="btn_outer text_right">
                        <el-upload
                          class="upload-demo"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          :on-preview="handlePreview"
                          :on-remove="handleRemove"
                          :before-remove="beforeRemove"
                          :on-exceed="handleExceed"
                          :http-request="htrupl"
                        >
                          <el-button size="small" type="primary">点击上传</el-button>
                          <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                        </el-upload>
                        <!--<el-button type="primary" plain> <i class="cloudicon ci_upload"></i> <div>上传</div></el-button>-->
                      </div>

                    </td>
                  </tr>
                </table>

              </div>
            </div>

            <div class="form_cont_module">
              <div class="m_head">
                三、企业发展概况
              </div>
              <div class="d_content">
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg">企业发展</td>
                  </tr>
                  <td>
                  	<el-form-item  prop="corp_dev">
                    	<el-input :readonly="mode==='view'"  type="textarea" :rows="4" placeholder="主要描述发展业绩、行业地位及市场份额、相关经验总结等，限600字"
                              v-model="sbInfo.corp_dev"></el-input>
                    </el-form-item>
                  </td>
                </table>
              </div>
            </div>

            <div class="form_cont_module">
              <div class="m_head">
                四、企业经营情况
              </div>
              <div class="d_content">
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg" colspan="4">（一）资源使用情况</td>
                  </tr>
                  <tr>
                    <td class="td_bg text_center" width="100px">
                      项目类型
                      <el-select :disabled="mode==='view'" v-model="sbInfo.xmlx" placeholder="请选择" @change="indChange" style="width:100%">
                        <el-option
                          v-for="item in xmlxOpts"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>

                    </td>
                    <td class="td_bg text_center">土地项目用地面积<br/>（平方米/折亩数）</td>
                    <td class="td_bg text_center">租凭厂房项目建筑面积<br/>（平方米/按容积率折亩数）</td>
                    <td class="td_bg text_center">租赁楼宇项目建筑面积<br/>（平方米/按容积率折亩数）</td>
                  </tr>
                  <tr>
                    <td class="td_bg text_center">楼宇项目</td>
                    <td>
                      <div class="td_flex">
                        <el-input  :readonly="mode==='view'" onkeyup ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.pro_ydmj_pf" placeholder="请输入数字"></el-input>&nbsp;/&nbsp;<el-input :readonly="mode==='view'" onkeyup ="value=value.replace(/[^0-9.]/g,'')"  v-model="sbInfo.pro_ydmj_m" placeholder="请输入数字"></el-input>
                      </div>
                    </td>
                    <td>
                      <div class="td_flex">
                        <el-input v-model="sbInfo.cf_znmj_pf"   placeholder="请输入数字" :readonly="mode==='view'" onkeyup ="value=value.replace(/[^\d]/g,'')"></el-input>&nbsp;/&nbsp;<el-input v-model="sbInfo.cf_znmj_m" placeholder="请输入数字" :readonly="mode==='view'" onkeyup ="value=value.replace(/[^\d]/g,'')"></el-input>
                      </div>
                    </td>
                    <td>
                      <div class="td_flex">
                        <el-input v-model="sbInfo.ly_znmj_pf" onkeyup ="value=value.replace(/[^\d]/g,'')"  placeholder="请输入数字" :readonly="mode==='view'"></el-input>&nbsp;/&nbsp;<el-input v-model="sbInfo.ly_znmj_m" placeholder="请输入数字" onkeyup ="value=value.replace(/[^\d]/g,'')" :readonly="mode==='view'"></el-input>
                      </div>
                    </td>
                  </tr>
                </table>
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg" colspan="4">（二）公司财务状况</td>
                  </tr>
                  <tr>
                    <td class="td_bg text_center">财务指标</td>
                    <td class="td_bg text_center">{{ sbInfo.ayear_val }}年</td>
                    <td class="td_bg text_center">{{ sbInfo.byear_val }}年</td>
                    <td class="td_bg text_center">{{ sbInfo.cyear_val }}年</td>
                  </tr>
                  <tr>
                    <td class="td_bg">近年产值或营业收入（万元）</td>
                    <td>
                      <el-input oninput="value=value.replace(/[^0-9.]/g,'')"  v-model="sbInfo.ayear_pro" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input oninput ="value=value.replace(/[^0-9.]/g,'')"  v-model="sbInfo.byear_pro" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input oninput ="value=value.replace(/[^0-9.]/g,'')"  v-model="sbInfo.cyear_pro" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">近年税收（万元）</td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.ayear_tax" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.byear_tax" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.cyear_tax" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">近年亩均税收（万元）</td>
                    <td>
                      <el-input oninput ="value=value.replace(/[^0-9.]/g,'')"  v-model="sbInfo.ayear_mjss" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.byear_mjss" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.cyear_mjss" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">每平方米税收（元）</td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.ayear_pfss" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.byear_pfss" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.cyear_pfss" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">近年研发投入（万元）</td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.ayear_yf" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.byear_yf" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="sbInfo.cyear_yf" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                </table>

                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg" colspan="4">（三）人员构成</td>
                  </tr>
                  <tr>
                    <td class="td_bg">总人数（人）</td>
                    <td>
                      <el-input oninput ="value=value.replace(/[^\d]/g,'')" v-model="sbInfo.total_per" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td class="td_bg">全日制博士（人）</td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^\d]/g,'')" v-model="sbInfo.doctor_num" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="td_bg">全日制硕士（人）</td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^\d]/g,'')" v-model="sbInfo.master_num" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                    <td class="td_bg">全日制本科（人）</td>
                    <td>
                      <el-input  oninput ="value=value.replace(/[^\d]/g,'')" v-model="sbInfo.under_num" placeholder="请输入数字" :readonly="mode==='view'"></el-input>
                    </td>
                  </tr>
                </table>
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg" colspan="4">（四）近三年是否有工商、税务、质量、环保、安全等处罚记录</td>
                  </tr>
                  <tr>
                    <td>
                    	<el-form-item  prop="punishRecord">
	                      <el-radio v-model="punishRecord" label="1" :disabled="mode==='view'">是</el-radio>
	                      <el-radio v-model="punishRecord" label="2" :disabled="mode==='view'">否</el-radio>
	                    </el-form-item>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="form_cont_module">
              <div class="m_head">
                五、企业承诺
              </div>
              <div class="d_content">
                <table border="0" cellspacing="0" cellpadding="0" class="table">
                  <tr>
                    <td class="td_bg">
                      1、本申报表中所填写的内容符合企业实际情况，数据准确并经核实。<br/>
                      2、提供认定的申报表附件资料真实、可信。<br/>
                      3、本企业在近三年内，合法经营生产，无偷税、漏税、走私和生产、销售假冒伪劣产品等违法行为。<br/>
                      4、企业主导产品知识产权或商业秘密明晰完整，未剽窃他人成果、未侵犯他人的知识产权或商业秘密。若发生与上述承诺相违背的事实，由本企业承担全部责任。
                    </td>
                  </tr>
                  <tr v-if="mode!=='view'">
                    <td>
                    	<el-form-item  prop="type">
                      	<el-checkbox @change="onReadChange()" v-model="read" :readonly="mode==='view'">我已阅读</el-checkbox>
                      </el-form-item>
                    </td>
                  </tr>
                </table>
              </div>
            </div>


            <div class="save_btn_outer" v-if="mode!=='view'">
              <el-button type="primary" :disabled="read==='read'"  plain @click="onAddProject(1,'ruleForm')">
                <div>提交</div>
              </el-button>
              <el-button type="primary" :disabled="read==='read'" plain @click="onAddProject(0,'ruleForm')">
                <div>暂存</div>
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'

export default {
  created() {
    let redisKey= this.$route.query.rediskey;
    if(redisKey!==undefined && redisKey!==null){
      window.localStorage.setItem("gyzhqy_token",redisKey);
      this.rediskey=redisKey;
    }

    let id =this.id || this.$route.query.id;
    let mode=this.modeD || this.$route.query.mode;
    if(mode!==undefined && mode!==null){
      this.mode=mode;
    }

    if (id !== undefined && id !== null) { // 这里是修改或者查看
      this.getDetail(id);


    } else {                          // 新增
      this.sbInfo.policy_id = this.$route.query.policy_id;
      let thisYear = new Date().getFullYear();
      this.sbInfo.ayear_val = thisYear - 3;
      this.sbInfo.byear_val = thisYear - 2;
      this.sbInfo.cyear_val = thisYear - 1;

      if (JSON.parse(window.localStorage.getItem("gyzhqy_corp_info")) != null) {
        let corpInfo = JSON.parse(window.localStorage.getItem("gyzhqy_corp_info"));
        this.sbInfo.cname=corpInfo.cname;
        this.sbInfo.qyxz=corpInfo.qyxz;
        this.sbInfo.opername=corpInfo.opername;
        this.sbInfo.address=corpInfo.address;
      }
    }
  },
  name: 'declare',
  props: ['id','modeD'],
  mounted() {
  	this.cnsGL = this.loadAll();
	},
  data() {
    return {
      rediskey:null,
      mode:'',
      cnsGL: [],
      cnameGL: '',
      timeout: null,
      filesList: [
        /* { name: 'xxx.jpg', createtime: '2020年09月18日'}*/
      ],
      qyName: '',
      nature: '',
      representative: '',
      edate: '',
      Industry: '',
      options: [{
        value: 1,
        label: '科技创新类'
      }, {
        value: 2,
        label: '结构调整类'
      }, {
        value: 3,
        label: '循环经济类'
      }, {
        value: 4,
        label: '品牌建设类'
      }, {
        value: 5,
        label: '融资上市类'
      },
        {
          value: 6,
          label: '提升管理类'
        }, {
          value: 7,
          label: '人才引进类'
        }, {
          value: 8,
          label: '盘活资源类'
        }, {
          value: 9,
          label: '重点产业类'
        }, {
          value: 10,
          label: '平台经济类'
        }, {
          value: 11,
          label: '其他'
        }
      ],
      xmlxOpts: [
        {
          value: 1,
          label: '土地项目'
        }, {
          value: 2,
          label: '厂房项目'
        },
        {
          value: 3,
          label: '楼宇项目'
        }
      ],
      qyxzOpts: [
        {value: 1, label: '内资'},
        {value: 2, label: '外资'},
        {value: 3, label: '港澳台'}
      ],

      ftUG: '',
      punishRecord: '2',
      read: false,
      sbInfo: {
        policy_id: null,
        cname: null,
        qyxz: null,
        opername: null,
        startday: null,
        sshy: null,
        address: null,
        zycp: null,
        agent: null,
        corp_tel: null,
        sb_cate: null,
        sbxl: null,
        xmbh: null,
        pro_intro: null,
        corp_dev: null,
        xmlx: null,
        pro_ydmj_pf: null,
        pro_ydmj_m: null,
        cf_znmj_pf: null,
        cf_znmj_m: null,
        ly_znmj_pf: null,
        ly_znmj_m: null,


        ayear_pro: null,
        byear_pro: null,
        cyear_pro: null,

        ayear_tax: null,
        byear_tax: null,
        cyear_tax: null,

        ayear_mjss: null,
        byear_mjss: null,
        cyear_mjss: null,

        ayear_pfss: null,
        byear_pfss: null,
        cyear_pfss: null,

        ayear_yf: null,
        byear_yf: null,
        cyear_yf: null,

        total_per: null,
        doctor_num: null,
        master_num: null,
        under_num: null,
        cfjl: null,
        qycl: null,
        ayear_val: null,
        byear_val: null,
        cyear_val: null
      },
    	ruleForm: {
          cname: '',
          qyxz: '',
          startday: '',
          corp_dev: '',
//        punishRecord:'',
          agent:'',
          corp_tel:''
     },
     rules: {
          cname: [
            {type: 'string', required: true, message: '请输入企业名称', trigger: 'blur' },
            { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
          ],
       agent: [
         {type: 'string', required: true, message: '请输入经办人', trigger: 'change' },
         { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change' }
       ],
       corp_tel: [
         {type: 'string', required: true, message: '请输入联系电话', trigger: 'change' },
       ],
       corp_dev: [
         { min: 0, max: 600, message: '企业发展描述不能超过600字', trigger: 'blur' }
       ]
      }
    }
  },
  methods: {
    indChange(e) {
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    htrupl(param) {
      let fileName = param.file.name.lastIndexOf(".");//取到文件名开始到最后一个点的长度
      let fileNameLength = param.file.name.length;//取到文件名长度
      let fileFormat = param.file.name.substring(fileName + 1, fileNameLength);//截
      const formData = new FormData()
      formData.append('file', param.file);
      this.$ajax.post(this.bUrl + 'api/portal/user/webuploader?_ajax=1&filetype=file', formData).then(function (res) {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg);
          this.filesList.push(res.data.data);
        } else {
          this.$message.error(res.data.msg)
        }
      }.bind(this)).catch(function (error) {
        console.log(error);
      });
    },
    downloadFile(url,name) {

      this.$down.download (url, name)
    },

    onReadChange(){
    },

    calcTime() {
      let _date = new Date();
      let _month = _date.getMonth() + 1;
      _month = _month < 10 ? '0' + _month : _month;
      let _day = _date.getDate();
      _day = _day < 10 ? '0' + _day : _day;
      let _hour = _date.getHours();
      _hour = _hour < 10 ? '0' + _hour : _hour;
      let _minute = _date.getMinutes();
      _minute = _minute < 10 ? '0' + _minute : _minute;
      _date = _date.getFullYear() + '年' + _month + '月' + _day + '日' + _hour + '时' + _minute + '分'
      return _date
    },
    async onAddProject(status,formName) {
      if(!this.read){
        this.$message.error("请先阅读企业承诺")
        return;
      }

    	this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addProject(status)
          } else {
            console.log('error submit!!');
            setTimeout(()=>{
              var isError = document.getElementsByClassName("is-error");
              console.log(isError)
              var htmlInputElement = isError[0].querySelector('input');
              if(htmlInputElement) htmlInputElement.focus();

              var htmlAreaElement = isError[0].querySelector('textarea');
              if(htmlAreaElement) htmlAreaElement.focus();
            },100);
            return false;
          }
        });
    },
   async addProject(status){
     let data = this.sbInfo;
     data.xmmc = '上海市工业综合开发区产业创新和发展基金项目'
     data.status = status;
     data.attachments = this.filesList.map(item => item.id).join(',')
     let res01 = await this.$ajax.post(this.bUrl + 'api/portal/zxzj/save', data);
     if (res01.data.code === 200) {
       this.$message.success(res01.data.msg);
       this.$emit('emitClose')
       if(this.$route.query.fname=='notidetail'){this.$router.push({name:'userproject'})}
     } else {
       this.$message.error(res01.data.msg);
       this.$emit('emitClose')
     }
   },
    del(index) {
      this.filesList.splice(index, 1)
    },
    async getDetail(id) {
      let res = await this.$ajax.get(this.bUrl + 'api/portal/zxzj/detail?id=' + id);
      for (let key in this.sbInfo) {
        this.sbInfo[key] = res.data.data[key];
      }
      this.filesList = res.data.data.attachments;
    },

    loadAll() {
      return [
        {"value": "开图信息", "address": "长宁区新渔路144号"},
        {"value": "羿天文化", "address": "上海市长宁区淞虹路661号"},
        {"value": "和皓自控", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113"},
        {"value": "建设银行", "address": "天山西路438号"},
        {"value": "娃哈哈", "address": "上海市长宁区金钟路968号1幢18号楼一层商铺18-101"},
        {"value": "军睿信息技术", "address": "上海市长宁区金钟路633号"}
      ];
    },
    querySearchAsync(queryString, cb) {
      var cnsGL = this.cnsGL;
      var results = queryString ? cnsGL.filter(this.createcnameGLFilter(queryString)) : cnsGL;
      cb(results);
    },
    createcnameGLFilter(queryString) {
      return (cnameGL) => {
        return (cnameGL.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
    handleSelect(item) {
    }

  }
}
</script>

<style scoped>
.declare_outer {
  background: #fff;
}

.declare_cont {
  width: 1180px;
  margin: 0 auto;
  padding:36px 66px;
  box-sizing: border-box;
  color: #666666;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  margin-top: 20px;
}

.declare_cont .head {
  text-align: center;
  /*margin-bottom: 20px;*/
}

.declare_cont .head .tit {
  font-size: 24px;
  color: #5F5F5F;
}

.form_cont_module {
  margin-bottom: 26px;
}

.form_cont_module .m_head {
  line-height: 50px;
  font-size: 18px;
}

.save_btn_outer {
  text-align: center;
  margin-top: 44px;
}


</style>



// WEBPACK FOOTER //
// src/components/NotiDeclare/declare.vue